import { CookieRestClient } from '@idem/common/rest/cookie-rest-client';

export interface SeccionAjena {
  id: string;
  nombre: string;
  slug: string;
  quienLaManeja: string;
  congelada: boolean;
}

const rest = new CookieRestClient();

export const todasLasSecciones = (): Promise<SeccionAjena[]> => rest.get('super/secciones');

export const terminarSeccion = (id: string) => rest.delete(`super/secciones/${id}`);
